import { CartIconV2 } from "../../../../assets/svgIcons/SellModeIconsV2/CartIconV2";
import { useCart } from "../../../../hooks/useCart";
import styles from "./styles.module.scss";

export const CartBtn = () => {
  const { cartItems } = useCart({});
  return (
    <span className={styles.cartBtn}>
      <span className={styles.cartIcon}>
        <CartIconV2 />
        <span>{cartItems?.length}</span>
      </span>
      <span className="white--text" style={{ fontSize: "12px" }}>
        Cart
      </span>
    </span>
  );
};
